import PropTypes from 'prop-types';
import logoImg from 'public/static/icon-192.png';
import React, { useEffect, useState } from 'react';
import { api } from 'src/utils/api';
import { API_RESOURCES, BUREAU_BARCODE_FORMAT } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

import BarcodeQrCodeOutput from './BarcodeQrCodeOutput';

const TravelerCompact = ({ piece, scanningMode, bureauBranding }) => {
  const [qrUrl, setQrUrl] = useState('');
  const [bureauLogoSrc, setBureauLogoSrc] = useState(null);
  const bureauLogo = bureauLogoSrc;

  useEffect(() => {
    if (piece?.uri) {
      const url = new URL(`${window.location.origin}/summary`);
      url.searchParams.set('scannedPiece', getUuid(piece.uri));
      setQrUrl(String(url));
    }
  }, [piece?.uri]);

  useEffect(() => {
    const resolveBureauLogo = async () => {
      const logoUri = bureauBranding?.printable_logo || bureauBranding?.logo || null;
      if (!logoUri) {
        setBureauLogoSrc(null);
        return;
      }

      if (logoUri.includes(`/${API_RESOURCES.DOCUMENT}/`)) {
        try {
          const document = await api.get(`${API_RESOURCES.DOCUMENT}/${getUuid(logoUri)}/`).json();
          setBureauLogoSrc(document?.upload_location || logoUri);
          return;
        } catch (error) {
          console.error(error);
        }
      }

      setBureauLogoSrc(logoUri);
    };

    resolveBureauLogo();
  }, [bureauBranding]);

  const isQr = scanningMode === BUREAU_BARCODE_FORMAT.QR;

  return (
    <div className='traveler traveler--compact'>
      <h1>{piece ? piece.name : 'N/A'}</h1>

      <BarcodeQrCodeOutput
        url={qrUrl}
        scanningMode={scanningMode}
        className={isQr && 'qr--compact'}
      />

      <footer>
        {bureauLogo ? (
          <p className='bureau-logo-footer'>
            <img className='custom-logo' src={bureauLogo} alt='Bureau Logo' />
          </p>
        ) : (
          <p>
            Powered by <img className='logo' src={logoImg} alt='Powered by Authentise' /> Authentise
          </p>
        )}
      </footer>
    </div>
  );
};

// API results are camelcase ¯\_(ツ)_/¯
/* eslint-disable camelcase */
TravelerCompact.propTypes = {
  piece: PropTypes.shape({
    name: PropTypes.string,
    uri: PropTypes.string,
  }),
  scanningMode: PropTypes.string,
  bureauBranding: PropTypes.shape({
    logo: PropTypes.string,
    printable_logo: PropTypes.string,
  }),
};

TravelerCompact.defaultProps = {
  piece: null,
  scanningMode: BUREAU_BARCODE_FORMAT.QR,
  bureauBranding: null,
};
/* eslint-enable camelcase */

export default TravelerCompact;
